/**
 * Temporary release flag: restrict app to Smart Dine In only.
 * Keep non-smart-dine-in code in place, but block navigation to those flows.
 */
export const SMART_DINE_IN_ONLY = true

/** Routes blocked while SMART_DINE_IN_ONLY is enabled. */
export const BLOCKED_WHEN_SMART_DINE_IN_ONLY: string[] = []

/** Keep Order Online visible in flow switchers, but prevent selecting it for now. */
export const ORDER_ONLINE_DISABLED = true
